import React from 'react';

// Splits letter text on blank lines so multi-paragraph letters render properly.
function LetterText({ text, photos = [] }) {
  const paragraphs = (text || '')
    .split(/\n\s*\n/)
    .map(p => p.trim())
    .filter(Boolean);

  return (
    <div className="letter-text">
      {paragraphs.map((paragraph, i) => (
        <React.Fragment key={i}>
          <p className="content">{paragraph}</p>
          {photos.filter(photo => photo.afterParagraph === i).map(photo => (
            <figure className="letter-photo" key={photo.src}>
              <img
                src={photo.src}
                alt={photo.alt}
                width={photo.width}
                height={photo.height}
                loading="lazy"
                decoding="async"
              />
              <figcaption>{photo.caption}</figcaption>
            </figure>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
}

export default LetterText;
